import React from 'react';

import { useIntl } from 'react-intl';

import ExternalLink from 'components/external-link';

import { OptInLabel, TermsLink, TermsText } from '../styled';

import { RewardsPolicyTermsLink } from './rewards-policy-terms-link';
import { usePromoEmailMessage } from './use-promo-email-message';

export const UrlLabel = (text: string, url: string) => {
  return (
    <OptInLabel>
      <ExternalLink href={url}> {text} </ExternalLink>
    </OptInLabel>
  );
};

export const PromotionalEmailsLabel = () => {
  const { formatMessage } = useIntl();
  const message = usePromoEmailMessage();

  return (
    <OptInLabel data-testid={`opt-in-label-${message}`}>
      {formatMessage({ id: message })}
    </OptInLabel>
  );
};

export const TermsOfServiceLabel = () => {
  const { formatMessage } = useIntl();

  const privacyPolicyLink = (
    <TermsLink to={formatMessage({ id: 'routes.privacyPolicy' })}>
      {formatMessage({ id: 'privacyPolicy' })}
    </TermsLink>
  );

  const rewardsPolicyLink = <RewardsPolicyTermsLink />;

  const termsOfServiceLink = (
    <TermsLink to={formatMessage({ id: 'routes.termsOfService' })}>
      {formatMessage({ id: 'termsOfService' })}
    </TermsLink>
  );

  return (
    <OptInLabel>
      {formatMessage(
        { id: 'acceptTermsAndPrivacyIntro' },
        { termsOfServiceLink, privacyPolicyLink, rewardsPolicyLink }
      )}
    </OptInLabel>
  );
};
export const TermsOfServiceLabelForPrivacyPolicy = () => {
  const { formatMessage } = useIntl();

  const privacyPolicyLink = <TermsText>{formatMessage({ id: 'privacyPolicies' })}</TermsText>;

  const rewardsPolicyLink = <RewardsPolicyTermsLink />;

  const termsOfServiceLink = (
    <TermsLink to={formatMessage({ id: 'routes.termsOfService' })}>
      {formatMessage({ id: 'termsOfService' })}
    </TermsLink>
  );

  return (
    <OptInLabel>
      {formatMessage(
        { id: 'acceptTermsAndPrivacyIntro' },
        { termsOfServiceLink, privacyPolicyLink, rewardsPolicyLink }
      )}
    </OptInLabel>
  );
};
